var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.2956C11 12.5433 11.5268 13.7398 12.4645 14.6221C13.4021 15.5043 14.6739 15.9999 16 15.9999C17.3261 15.9999 18.5979 15.5043 19.5355 14.6221C20.4732 13.7398 21 12.5433 21 11.2956C21 10.048 20.4732 8.85139 19.5355 7.96917C18.5979 7.08694 17.3261 6.59131 16 6.59131C14.6739 6.59131 13.4021 7.08694 12.4645 7.96917C11.5268 8.85139 11 10.048 11 11.2956Z",
    stroke: "#3C4D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.88721C18.6522 1.88721 21.1957 2.87847 23.0711 4.64292C24.9464 6.40738 26 8.80049 26 11.2958C26 15.5698 19.2347 26.2868 16.8333 29.6928C16.7421 29.8221 16.6183 29.9283 16.4729 30.0017C16.3275 30.0751 16.165 30.1135 16 30.1135C15.835 30.1135 15.6725 30.0751 15.5271 30.0017C15.3817 29.9283 15.2579 29.8221 15.1667 29.6928C12.7653 26.2868 6 15.5698 6 11.2958C6 8.80049 7.05357 6.40738 8.92893 4.64292C10.8043 2.87847 13.3478 1.88721 16 1.88721V1.88721Z",
    stroke: "#3C4D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationDesktop);
export default __webpack_public_path__ + "static/media/location_desktop.384a75be46cd5e60b6abf3b30748a205.svg";
export { ForwardRef as ReactComponent };